import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import ListaNcmService from 'business/cadastro/fiscal/listaNcm/listaNcmService'
import OutputSpanForm from 'base/OutputSpanForm'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { cd, createCodeDescriptionObject, formatDatetime } from 'helper/formater'
import ListaNcmItem from './listaNcmItem/ListaNcmItem'
import TipoListaNcmService from 'business/cadastro/fiscal/tipoListaNcm/tipoListaNcmService'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

export default function ListaNcm() {

    const [service] = useState(() => new ListaNcmService())
    const [listaNcms, setListaNcms] = useState([])
    const [tipoListaNcms, setTipoListaNcms] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.lista_ncm) {
            setListaNcms([createCodeDescriptionObject(data.lista_ncm, 'codigo_linc', 'descricao_linc', true)])
        }
        if (data?.tipo_lista_ncm) {
            setTipoListaNcms([createCodeDescriptionObject(data.tipo_lista_ncm, 'codigo_tilin', 'descricao_tilin', false)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadTipoListaNcms = async () => {
        const list = new TipoListaNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tilin', 'descricao_tilin', false))
            options.push({ codigo_tilin: null, descricao_tilin: defaultEmptySelection() })
            setTipoListaNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="descricao_linc" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="cod_tilin_linc" form={form} type="dropdown2" service={service} label="Tipo de lista de NCM"
                            optionKey='codigo_tilin'
                            optionLabel='descricao_tilin'
                            options={tipoListaNcms}
                            onLoad={loadTipoListaNcms}
                        />

                        <ListaNcmItem form={form} service={service}></ListaNcmItem>

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                        <OutputSpanForm field="dh_ins_linc" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_linc'))} label="Inserção" />
                        <OutputSpanForm field="dh_atua_linc" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_linc'))} label="Atualização" />
                        <OutputSpanForm field="usu_ins_linc" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_ins_linc'), description: form.getValues('meta.usuario_ins_nome') })} label="Inserção" />
                        <OutputSpanForm field="usu_atua_linc" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_atua_linc'), description: form.getValues('meta.usuario_atua_nome') })} label="Atualização" />
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
